<template>
  <div :class="classTable">
    <el-table
      ref="rootTable"
      :data="autoData"
      style="width: 100%"
      v-loading="autoLoading"
      v-bind="$attrs"
    >
      <el-table-column
        width="50"
        fixed
        align="center"
        v-if="actions !== undefined"
      >
        <template slot="header" slot-scope="scope">
          <i class="el-icon-setting" :key="scope.$index"></i>
        </template>
        <template slot-scope="scope">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="mdi mdi-menu"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <template v-for="(action, index) in actions">
                <el-dropdown-item
                  v-if="
                    action.condition !== undefined &&
                    typeof action.condition === 'function'
                      ? action.condition(scope.row)
                      : true
                  "
                  :key="index"
                  :command="{
                    index: scope.$index,
                    row: scope.row,
                    column: scope.column,
                    command: action.command
                  }"
                  :icon="action.icon"
                  >{{ action.label }}</el-dropdown-item
                >
              </template>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>

      <el-table-column
        v-for="(column, index) in columns"
        :key="index"
        v-bind="column"
        :formatter="
          typeof column.formatter === 'function' ? column.formatter : null
        "
      >
        <template
          #default="{ row }"
          v-if="typeof column.formatter !== 'function'"
        >
          <div
            v-if="column.formatter"
            :is="column.formatter"
            v-bind="{
              row: row,
              column: column.prop,
              ...column.cellAtrrs,
              ...column.attrs
            }"
          ></div>
          <template v-else>
            {{ row[column.prop] }}
          </template>
        </template>
      </el-table-column>
    </el-table>

    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "RabbeyTable4",
  props: {
    data: {
      type: Array,
      required: false
    },
    columns: {
      type: Array
    },
    actions: {
      type: Array,
      required: false
    },
    url: {
      type: String,
      default: null,
      required: false
    },
    requestConfig: {
      type: Object,
      default: function () {
        return {};
      },
      required: false
    },
    /**
     * Css classes for the table container.
     */
    classTable: {
      type: Object,
      default() {
        return {
          "table-box": true,
          "card-base": true,
          "card-shadow--medium": true
        };
      }
    }
  },
  data() {
    return {
      autoData: [],
      autoLoading: false
    };
  },
  created() {
    if (this.url !== null) {
      this.refreshTable();
    } else {
      this.autoData = this.data;
    }
  },
  watch: {
    requestConfig() {
      this.refreshTable();
    }
  },
  methods: {
    handleCommand(command) {
      return this.$emit("rtable-push-action", command);
    },
    refreshTable() {
      this.autoLoading = true;
      this.$http
        .get(this.url, this.requestConfig)
        .then((resp) => {
          this.autoData = resp.data;
        })
        .finally(() => {
          this.$refs.rootTable.doLayout();
          this.autoLoading = false;
        });
    }
  }
};
</script>

<style></style>
